import React from 'react'
import { FiArchive, FiCheckCircle, FiClock, FiXCircle } from 'react-icons/fi'
import { IoHelp } from 'react-icons/io5'

export type UnitActivationStatusKey = 'awaitingstart' | 'awaitingpowerup' | 'pending' | 'success' | 'cancelled' | 'failed' | 'archived'

type IconProps = {
  className?: string
}

/**
 * Animated "working" indicator:
 * - subtle orbiting dots (no SVG dependency)
 * - inherits text color
 */
export const WorkingDotsIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <span className={`relative inline-flex items-center justify-center ${className ?? ''}`}>
      <span className='absolute inline-flex h-2.5 w-2.5 rounded-full bg-current opacity-70 animate-ping' />
      <span className='relative inline-flex h-2.5 w-2.5 rounded-full bg-current' />
    </span>
  )
}

/**
 * Optional: a "spinner ring" if you prefer.
 * (Also inherits text color)
 */
export const SpinnerRingIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <span
      className={['inline-block h-4 w-4 rounded-full border-2 border-current/30 border-t-current animate-spin', className ?? ''].join(' ')}
    />
  )
}

/**
 * Pick ONE of the animated indicators above:
 * - WorkingDotsIcon (ping dot)
 * - SpinnerRingIcon (small ring)
 */
const WorkingIcon = WorkingDotsIcon

export const UnitActivationStatusIcon: Record<UnitActivationStatusKey, React.FC<IconProps>> = {
  awaitingstart: FiClock,
  awaitingpowerup: WorkingIcon,
  pending: WorkingIcon,
  success: FiCheckCircle,
  cancelled: FiXCircle,
  failed: FiXCircle,
  archived: FiArchive
}

/**
 * Helper if you ever get an unknown status from backend safely.
 */
export const getUnitActivationStatusIcon = (status?: string | null): React.FC<IconProps> => {
  const key = status as UnitActivationStatusKey
  return UnitActivationStatusIcon[key] ?? IoHelp
}
